import '../assets/stylus/main.styl';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { IndexRoute, Route, Router, hashHistory } from 'react-router';

import Analytics from './components/Analytics';
import App from './components/App';
import Approval from './components/Approval';
import DeviceTest from './components/DeviceTest';
import ErrorComponent from './components/ErrorComponent';
import GlanceDraftRedirect from './pages/drafts//GlanceDraftRedirect';
import GlanceDrafts from './pages/drafts/GlanceDrafts';
import GlanceStudioApp from './components/GlanceStudioApp';
import HighLights from './components/HighLights';
import InternalApprovalGlances from './components/InternalApprovalGlances';
import LoginComponent from './components/LoginComponent';
import Logout from './components/Logout';
import ModeratorGlances from './components/ModeratorGlances';
import Notification from './components/Notification';
import PartnerGlances from './components/PartnerGlances';
import PeekView from './components/PeekView';
import { Provider } from 'react-redux';
import Publishers from './components/Publishers';
import ResetPassword from './components/ResetPassword';
import SegmentQuery from './pages/segmentQuery';
import Segments from './components/Segments';
import UploadCsv from './components/UploadCsv';
import UploadFile from './components/UploadFile';
import configureStore from './store/configureStore';

const store = configureStore({}); // You can also pass in an initialState here

// Commented out ("let HTML app be HTML app!")
window.addEventListener('DOMContentLoaded', () => {
  const rootEl = document.getElementById('root');

  if (rootEl) {
    ReactDOM.render(
      <Provider store={store}>
        <Router history={hashHistory}>
          <Route path="/device/test" component={DeviceTest} />
          <Route path="/password/generate" component={ResetPassword} />
          <Route path="/" component={GlanceStudioApp}>
            <Route path="/login" component={LoginComponent}></Route>
            <Route path="/logout" component={Logout} />

            <Route component={App}>
              <Route path="/partner">
                <IndexRoute component={PartnerGlances} />
                <Route path="/partner/:partnerId/settings" component={Logout} />
                <Route path="/partner/:partnerId" component={PartnerGlances} />

                <Route
                  path="/partner/:partnerId/published"
                  component={PartnerGlances}
                >
                  <Route
                    path="/partner/:partnerId/published/:region/:regionName/"
                    component={PartnerGlances}
                  />
                  <Route
                    path="/partner/:partnerId/published/:region/:regionName/:filter/:filterName"
                    component={PartnerGlances}
                  />
                  <Route
                    path="/partner/:partnerId/published/:region/:regionName/:filter/:filterName/:type/:typeName"
                    component={PartnerGlances}
                  />
                </Route>
                <Route
                  path="/partner/:partnerId/glance/:id/:action"
                  component={Approval}
                />
              </Route>
              <Route path="/peek/:type(/:id)" component={PeekView} />
              <Route
                path="/drafts/draftIds/:draftIds"
                component={GlanceDraftRedirect}
              />
              <Route path="/error" component={ErrorComponent} />
              <Route path="/:role">
                <IndexRoute component={GlanceDrafts} />

                <Route path="/:role/drafts" component={GlanceDrafts}>
                  <Route
                    path="/:role/drafts/draftIds/:draftIds"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category/time/:time"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner/partnerRegion/:partnerRegion/regionFilter/:regionFilter"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner"
                    component={GlanceDrafts}
                  />
                  <Route
                    path="/:role/drafts/type/:typeName/:type/category/:category/time/:time/publishState/:publishStateName/:publishState/partner/:partner/partnerRegion/:partnerRegion/regionFilter/:regionFilter"
                    component={GlanceDrafts}
                  />
                </Route>

                <Route path="/:role/published" component={ModeratorGlances}>
                  <Route
                    path="/:role/published/:partnerId/:partnerName"
                    component={ModeratorGlances}
                  />
                  <Route
                    path="/:role/published/:partnerId/:partnerName/:region/:regionName"
                    component={ModeratorGlances}
                  />
                  {/*<Route path="/partner/published/:id" component={Glances}/>*/}
                </Route>
                <Route
                  path="/:role/internalApproval"
                  component={InternalApprovalGlances}
                >
                  <Route
                    path="/:role/internalApproval/:region/:regionName"
                    component={InternalApprovalGlances}
                  />
                </Route>
                <Route path="/:role/analytics" component={Analytics}>
                  <Route
                    path="/:role/analytics/:partnerId/:partnerName"
                    component={Analytics}
                  />
                  <Route
                    path="/:role/analytics/:partnerId/:partnerName/:region/:regionName"
                    component={Analytics}
                  />
                </Route>
                <Route path="/:role/publishers" component={Publishers}>
                  <Route
                    path="/:role/publishers/:partnerId/:partnerName"
                    component={Publishers}
                  />
                  <Route
                    path="/:role/publishers/:partnerId/:partnerName/:region/:regionName"
                    component={Publishers}
                  />
                </Route>
                <Route path="/:role/segments" component={Segments}>
                  <Route
                    path="/:role/segments/:partnerId/:partnerName"
                    component={Segments}
                  />
                  <Route
                    path="/:role/segments/:partnerId/:partnerName/:region/:regionName"
                    component={Segments}
                  />
                </Route>
                <Route
                  path="/:role/segment-query"
                  component={SegmentQuery}
                ></Route>
                {/* <Route path="/:role/highLights" component={HighLights}></Route> */}
                <Route path="/:role/uploadCsv" component={UploadCsv}>
                  <Route
                    path="/:role/uploadCsv/:partnerId/:partnerName"
                    component={UploadCsv}
                  />
                  <Route
                    path="/:role/uploadCsv/:partnerId/:partnerName/:region/:regionName"
                    component={UploadCsv}
                  />
                </Route>
                <Route path="/:role/uploadFile" component={UploadFile}></Route>
                <Route
                  path="/:role/notification-settings"
                  component={Notification}
                ></Route>
              </Route>
            </Route>
          </Route>
        </Router>
      </Provider>,
      rootEl,
    );
  }
});

$(document).ready(function() {
  console.log('Glance webapp is ready to be initialised.');
});



// WEBPACK FOOTER //
// ./src/index.tsx